var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestricciones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "limitaciones",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.74 61.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.89,65.04a30.865,30.865,0,1,0,0,43.67A30.7,30.7,0,0,0,221.89,65.04Zm-3.05,3.05a26.6,26.6,0,0,1,1.45,35.97L182.87,66.64a26.545,26.545,0,0,1,35.98,1.45Zm-37.57,37.57a26.6,26.6,0,0,1-1.45-35.97l37.42,37.42A26.577,26.577,0,0,1,181.27,105.66Z",
    transform: "translate(-169.18 -55.99)",
    fill: "#f03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestricciones);
export default __webpack_public_path__ + "static/media/restricciones.c8a2b5aa59aa951c1ab86efd23552042.svg";
export { ForwardRef as ReactComponent };